import { createSlice } from "@reduxjs/toolkit";
import { addKyc, createNominee, getKyc, deleteKyc, getAllAddresses, getNominee, getProfile, getProfileReference, setNomineePic, setProfilePic, updateKyc, updateNominee, updateProfile, getKYCDocuments, verifyKyc, getCredits, contactSupport, addNewAddress, updateAddress, deleteAddress, sendUserEmail, verifyUserEmail, getCreditHistory, createReferral } from "./customerActions";
import { TroubleshootRounded } from "@mui/icons-material";

const initialState = {
   loading: false,
   Info: {},
   nominee: {},
   kycInfo: [],
   ProfileReferenes: {
      countryList: [], stateList: [], kycIdList: []
   },
   kYCDocList: [],
   relationList: [],
   accessToken: null,
   error: null,
   message: null,
   success: null,
   callGetProfile: false,
   callGetNominee: false,
   OutOFCreditsPopUp: false,
   credits: 0,
   totalAddresses: 0,
   errorMessage: "",
   userProfilePicErrorMessage: "",
   kycErrorMessage: "",
   updateKycErrorMessage: "",
   deleteKycErrorMessage: "",
   shareKycErrorMessage: "",
   nomineeprofileErrorMessage: "",
   setNomineeProfilePicErrorMessage: "",
   addAddressErrorMessage: "",
   updateAddressErrorMessage: "",
   deleteAddressErrorMessage: "",
   referralCode: "",
   referredby: ""
}

const customerSlice = createSlice({
   name: "customerSlice",
   initialState,
   reducers: {
      clearCustomer: () => initialState,
      OutOFCreditsPopUpHandler: (state, { payload }) => {
         state.OutOFCreditsPopUp = payload;
      },
      clearCutomerErrorMessage: (state, action) => {
         state.errorMessage = ''
      },
      clearUserProfilePicErrorMessage: (state, action) => {
         state.userProfilePicErrorMessage = ''
      },
      clearCustomerKycDoc: (state, action) => {

         state.kycErrorMessage = ''
      },
      clearCustomerUpdateKycDoc: (state, action) => {

         state.updateKycErrorMessage = ''
      },
      clearCustomerDeleteKycDoc: (state, action) => {

         state.deleteKycErrorMessage = ''
      },
      clearCustomerShareKycDoc: (state, action) => {

         state.shareKycErrorMessage = ''
      },
      clearnomineeProfileUpdateError: (state, action) => {

         state.nomineeprofileErrorMessage = ''
      },
      clearnomineeProfilepicError: (state, action) => {

         state.setNomineeProfilePicErrorMessage = ''
      },
      clearCustomeraddAddressErrorMsg: (state, action) => {

         state.addAddressErrorMessage = ''
      },
      clearCustomerupdateAddressErrorMsg: (state, action) => {

         state.updateAddressErrorMessage = ''
      },
      clearCustomerdeleteAddressErrorMsg: (state, action) => {

         state.deleteAddressErrorMessage = ''
      },
      addtoCustomerwishList: (state, { payload }) => {
         //  state.Info.wishlists = [...payload]
         const existingWishlist = [...state.Info.wishlists, payload]
         state.Info.wishlists = existingWishlist

      },
      removeFromCustomerWishList: (state, { payload }) => {
         // state.Info.wishlists = [...payload]
         const existingWishlist = [...state.Info.wishlists]
         state.Info.wishlists = existingWishlist?.filter((existingpropertyid) => existingpropertyid !== payload)
      },
      updateCustomerWishList: (state, { payload }) => {


         if (!state.Info.wishlists.includes(payload)) {
            const existingWishlist = [...state.Info.wishlists, payload]
            state.Info.wishlists = existingWishlist
         } else {
            const existingWishlist = [...state.Info.wishlists]
            state.Info.wishlists = existingWishlist?.filter((existingpropertyid) => existingpropertyid !== payload)
         }
      },
      setrefferedByhandler: (state, { payload }) => {
         state.referredby = payload
      }
   },


   extraReducers: (builder) => {
      // get user Profile
      builder.addCase(getProfile.pending, (state) => {
         state.loading = true
      })
      builder.addCase(getProfile.fulfilled, (state, { payload }) => {
         state.loading = false
         state.Info = payload?.response?.data?.data?.item


         state.success = payload?.response?.data?.status?.type === "success"
      })
      builder.addCase(getProfile.rejected, (state, { payload }) => {

         state.loading = false
         state.error = true
      })

      // get Profile References 
      builder.addCase(getProfileReference.pending, (state) => {
         state.loading = true
      })
      builder.addCase(getProfileReference.fulfilled, (state, { payload }) => {
         state.loading = false
         state.success = payload?.response?.data?.status?.type === "success"
         state.relationList = payload?.response?.data?.data?.item
      })
      builder.addCase(getProfileReference.rejected, (state, { payload }) => {

         state.loading = false
         state.error = true
      })

      // get KYC Documents 
      builder.addCase(getKYCDocuments.pending, (state) => {
         state.loading = true
      })
      builder.addCase(getKYCDocuments.fulfilled, (state, { payload }) => {
         state.loading = false
         state.success = payload?.response?.data?.status?.type === "success"
         state.kYCDocList = payload?.response?.data?.data?.item
      })
      builder.addCase(getKYCDocuments.rejected, (state, { payload }) => {

         state.loading = false
         state.error = true
      })

      // Update Profile 
      builder.addCase(updateProfile.pending, (state) => {
         state.loading = true
      })
      builder.addCase(updateProfile.fulfilled, (state, { payload }) => {
         state.loading = false
      })
      builder.addCase(updateProfile.rejected, (state, { payload }) => {

         state.loading = false
         state.error = true

         if (payload?.status == 429) {
            if (state.errorMessage?.length !== '') {
               state.errorMessage = payload?.data?.status?.message
            }
         }
      })

      // set Profile Pic
      builder.addCase(setProfilePic.pending, (state) => {
         state.loading = true
      })
      builder.addCase(setProfilePic.fulfilled, (state, { payload }) => {

         state.loading = false
      })
      builder.addCase(setProfilePic.rejected, (state, { payload }) => {
         if (payload?.status == 429) {
            if (state.userProfilePicErrorMessage?.length !== '') {
               state.userProfilePicErrorMessage = payload?.data?.status?.message
            }
         }
         state.loading = false
         state.error = true
      })

      // send user email for verification

      builder.addCase(sendUserEmail.pending, (state) => {
         state.loading = true
      })
      builder.addCase(sendUserEmail.fulfilled, (state, { payload }) => {
         state.loading = false
      })
      builder.addCase(sendUserEmail.rejected, (state, { payload }) => {
         state.loading = false
         state.error = true
         if (payload?.status == 429) {
            if (state.errorMessage?.length !== '') {
               state.errorMessage = payload?.data?.status?.message
            }
         }
      })

      // verify user email otp

      builder.addCase(verifyUserEmail.pending, (state) => {
         state.loading = true
      })
      builder.addCase(verifyUserEmail.fulfilled, (state, { payload }) => {
         state.loading = false
      })
      builder.addCase(verifyUserEmail.rejected, (state, { payload }) => {
         state.loading = false
         state.error = true
         if (payload?.status == 429) {
            if (state.errorMessage?.length !== '') {
               state.errorMessage = payload?.data?.status?.message
            }
         }
      })


      // add KYC 
      builder.addCase(addKyc.pending, (state) => {
         state.loading = true
      })
      builder.addCase(addKyc.fulfilled, (state, { payload }) => {

         state.loading = false
         state.success = payload?.response?.data?.status?.type === "success";
      })
      builder.addCase(addKyc.rejected, (state, { payload }) => {

         if (payload?.status === 429) {
            if (state.kycErrorMessage?.length !== '') {
               state.kycErrorMessage = payload?.data?.status?.message
            }
         }

         state.loading = false
         state.error = true
      })

      // get KYC 
      builder.addCase(getKyc.pending, (state) => {
         state.loading = true
      })
      builder.addCase(getKyc.fulfilled, (state, { payload }) => {

         state.loading = false
         state.kycInfo = payload?.response?.data?.data?.items;
         state.success = payload?.response?.data?.status?.type === "success";
      })
      builder.addCase(getKyc.rejected, (state, { payload }) => {
         if (payload?.status === 429) {
            if (state.shareKycErrorMessage?.length !== '') {
               state.shareKycErrorMessage = payload?.data?.status?.message
            }
         }
         state.loading = false
         state.error = true
      })

      // update kyc
      builder.addCase(updateKyc.pending, (state) => {
         state.loading = true
      })
      builder.addCase(updateKyc.fulfilled, (state, { payload }) => {

         state.loading = false
         state.success = payload?.response?.data?.status?.type === "success";
      })
      builder.addCase(updateKyc.rejected, (state, { payload }) => {

         state.loading = false

         if (payload?.status === 429) {
            if (state.updateKycErrorMessage?.length !== '') {
               state.updateKycErrorMessage = payload?.data?.status?.message
            }
         }


         state.error = true
      })


      // verifyKyc 

      builder.addCase(verifyKyc.pending, (state) => {
         state.loading = true
      })
      builder.addCase(verifyKyc.fulfilled, (state, { payload }) => {

         state.loading = false


         state.success = payload?.response?.data?.status?.type === "success";
      })
      builder.addCase(verifyKyc.rejected, (state, { payload }) => {

         state.loading = false
         state.error = true
      })




      // delete customer kyc

      builder.addCase(deleteKyc.pending, (state) => {
         state.loading = true
      })
      builder.addCase(deleteKyc.fulfilled, (state, { payload }) => {

         state.loading = false
         state.success = payload?.response?.data?.status?.type === "success";
      })
      builder.addCase(deleteKyc.rejected, (state, { payload }) => {

         if (payload?.status === 429) {
            if (state.deleteKycErrorMessage?.length !== '') {
               state.deleteKycErrorMessage = payload?.data?.status?.message
            }
         }

         state.loading = false
         state.error = true
      })




      // set Nominee Pic
      builder.addCase(setNomineePic.pending, (state) => {
         state.loading = true
      })
      builder.addCase(setNomineePic.fulfilled, (state, { payload }) => {

         state.loading = false
         state.success = payload?.response?.data?.status?.type === "success"
      })
      builder.addCase(setNomineePic.rejected, (state, { payload }) => {
         if (payload?.status == 429) {
            if (state.setNomineeProfilePicErrorMessage?.length !== '') {
               state.setNomineeProfilePicErrorMessage = payload?.data?.status?.message
            }
         }
         state.loading = false
         state.error = true
      })

      // Create Nominee
      builder.addCase(createNominee.pending, (state) => {
         state.loading = true
      })
      builder.addCase(createNominee.fulfilled, (state, { payload }) => {

         state.loading = false
         state.success = payload?.response?.data?.status?.type === "success"
      })
      builder.addCase(createNominee.rejected, (state, { payload }) => {

         state.loading = false
         state.error = true
      })


      // getNominee 
      builder.addCase(getNominee.pending, (state) => {
         state.loading = true
      })
      builder.addCase(getNominee.fulfilled, (state, { payload }) => {

         state.loading = false
         state.success = payload?.response?.data?.status?.type === "success"
         state.nominee = payload?.response?.data?.data?.item
      })
      builder.addCase(getNominee.rejected, (state, { payload }) => {

         state.loading = false
         state.error = true
      })

      // Create Nominee
      builder.addCase(updateNominee.pending, (state) => {
         state.loading = true
      })
      builder.addCase(updateNominee.fulfilled, (state, { payload }) => {

         state.loading = false
         state.success = payload?.response?.data?.status?.type === "success"
      })
      builder.addCase(updateNominee.rejected, (state, { payload }) => {

         if (payload?.status == 429) {
            if (state.nomineeprofileErrorMessage?.length !== '') {
               state.nomineeprofileErrorMessage = payload?.data?.status?.message
            }
         }
         state.loading = false
         state.error = true
      })

      builder.addCase(getCredits.fulfilled, (state, { payload }) => {

         state.credits = payload?.response?.data?.data?.item?.credits
      })
      builder.addCase(getCredits.rejected, (state, { payload }) => {
         //
      })

      //  get all User Addresses 

      builder.addCase(getCreditHistory.fulfilled, (state, { payload }) => {
         state.credits = payload?.response?.data?.data?.item?.totalCredits
      })

      // getNominee 
      builder.addCase(getAllAddresses.pending, (state) => {
         state.loading = true
      })
      builder.addCase(getAllAddresses.fulfilled, (state, { payload }) => {




         state.totalAddresses = payload?.response?.data?.data?.count




      })
      builder.addCase(getAllAddresses.rejected, (state, { payload }) => {

         state.loading = false
         state.error = true
      })


      // add Address



      builder.addCase(addNewAddress.pending, (state) => {
         state.loading = true
      })
      builder.addCase(addNewAddress.fulfilled, (state, { payload }) => {

         state.loading = false
         state.success = payload?.response?.data?.status?.type === "success"
      })
      builder.addCase(addNewAddress.rejected, (state, { payload }) => {

         if (payload?.status == 429) {
            if (state.addAddressErrorMessage?.length !== '') {
               state.addAddressErrorMessage = payload?.data?.status?.message
            }
         }
         state.loading = false
         state.error = true
      })

      // update Address


      builder.addCase(updateAddress.pending, (state) => {
         state.loading = true
      })
      builder.addCase(updateAddress.fulfilled, (state, { payload }) => {

         state.loading = false
         state.success = payload?.response?.data?.status?.type === "success"
      })
      builder.addCase(updateAddress.rejected, (state, { payload }) => {

         if (payload?.status == 429) {
            if (state.updateAddressErrorMessage?.length !== '') {
               state.updateAddressErrorMessage = payload?.data?.status?.message
            }
         }
         state.loading = false
         state.error = true
      })

      // delete Address


      builder.addCase(deleteAddress.pending, (state) => {
         state.loading = true
      })
      builder.addCase(deleteAddress.fulfilled, (state, { payload }) => {

         state.loading = false
         state.success = payload?.response?.data?.status?.type === "success"
      })
      builder.addCase(deleteAddress.rejected, (state, { payload }) => {

         if (payload?.status == 429) {
            if (state.deleteAddressErrorMessage?.length !== '') {
               state.deleteAddressErrorMessage = payload?.data?.status?.message
            }
         }
         state.loading = false
         state.error = true
      })


      builder.addCase(contactSupport.pending, (state, { payload }) => {
         state.loading = true
      })
      builder.addCase(contactSupport.fulfilled, (state, { payload }) => {
         //
      })
      builder.addCase(contactSupport.rejected, (state, { payload }) => {
         state.loading = false
      })




      builder.addCase(createReferral.pending, (state, { payload }) => {
         state.loading = true
      })
      builder.addCase(createReferral.fulfilled, (state, { payload }) => {
         // state.ReferralCode = 
         state.referralCode = payload?.response?.data?.data?.item?.code
         //
      })
      builder.addCase(createReferral.rejected, (state, { payload }) => {
         state.loading = false
      })
   }
})

export default customerSlice.reducer

export const { clearCustomer, OutOFCreditsPopUpHandler, clearCutomerErrorMessage, clearUserProfilePicErrorMessage,
   clearCustomerKycDoc, clearCustomerUpdateKycDoc, clearCustomerDeleteKycDoc,
   clearCustomerShareKycDoc, clearnomineeProfileUpdateError, clearnomineeProfilepicError,
   clearCustomeraddAddressErrorMsg, clearCustomerupdateAddressErrorMsg, clearCustomerdeleteAddressErrorMsg, addtoCustomerwishList, removeFromCustomerWishList, updateCustomerWishList
   , setrefferedByhandler } = customerSlice.actions